/*
*   CRITICAL Changes:
*   1.  Refactored Initial Data Loading `useEffect`: The first `useEffect` hook, responsible for loading the initial assignment data, has been optimized.
*       Before, I had it so that if location.state is null, it'd fetch the assignment with submission. For some reason, the location.state would not be null
*       upon page refresh, so I just did away with it completely, lol.
*   2.  No Change to Socket `useEffect`. Everything looked good there.
*/

import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import styles from '../styles/AdminCanvasViewer.module.css';
import CanvasContext from '../../../context/CanvasContext';
import AdminCanvas from './AdminCanvas';
import AdminCanvasSidebar from './AdminCanvasSidebar';
import socket from './../../../socket';
import AdminCanvasDeleteModal from './AdminCanvasDeleteModal';
import * as ScenarioAPI from '../../../services/ScenarioServices';

const AdminCanvasViewer = () => {
    const navigate = useNavigate();

    const { scenarioId } = useParams();
    const {
        adminSelectedNode,
        adminSelectedEdge,
    } = useContext(CanvasContext);
    const [modal, setModal] = useState(false);

    const [deleteModal, showDeleteModal] = useState(false);

    const handleDeleteScenario = useCallback((event) => {
        event.stopPropagation();
        showDeleteModal(true);
    }, []);

    const handleConfirmDelete = async () => {
        await ScenarioAPI.deleteScenario(scenarioId);
        showDeleteModal(false)
        navigate('/admin');
    };

    const handleCancelDelete = useCallback(() => {
        showDeleteModal(false);
    }, []);

    return (
        <div className={styles.container}>
            <button className={styles.cornerButton} onClick={handleDeleteScenario}>
                Delete
            </button>
            <div className={styles.canvas}>
                <AdminCanvas setModal={setModal}/>
            </div>
            {modal && <div>
                <AdminCanvasSidebar onClose={() => setModal(false)} selectedNode={adminSelectedNode} selectedEdge={adminSelectedEdge} />
            </div>
            }
            {deleteModal && <AdminCanvasDeleteModal handleConfirmDelete = {handleConfirmDelete} handleCancelDelete={handleCancelDelete}/>}
        </div>
    );
};

export default AdminCanvasViewer;